// extracted by mini-css-extract-plugin
export default {"icon":"ContactsView_icon__yL3A6","field-icon":"ContactsView_field-icon__bk0NF","file-icon":"ContactsView_file-icon__Q5I1i"};